<template>
  <question-card
    v-if="leadHandled"
    hide-button
    class="questionnaire-intro"
  >
    <template #title>
      <span v-if="isStart">
        {{UIComponentData.Header.Start.Translations[questionnaireLead.Language]}}
      </span>
      <span v-else>
        {{UIComponentData.Header.Continue.Translations[questionnaireLead.Language]}}
      </span>
    </template>
    <div class="questionnaire-intro__navigation">
        <div class="questionnaire-intro__agreement md-layout-item md-xsmall-size-100 mb-5">
          {{UIComponentData.Link2.Translations[questionnaireLead.Language][0]}}<br>
          <privacy-policy :buttonName="UIComponentData.Link2.Translations[questionnaireLead.Language][1]"> </privacy-policy>
        </div>
        <v-button
          @click="handle"
          class="questionnaire-intro__button md-layout-item"
        >
          <span>{{UIComponentData.Button.Translations[questionnaireLead.Language]}}</span>
          <v-icon
        >keyboard_backspace</v-icon>
        </v-button>
      <div class="mt-5">
        <div
          @click="routeToHome()"
          class="questionnaire-intro__back-link"
          style="cursor:pointer;"
        >
          {{UIComponentData.Link1.Translations[questionnaireLead.Language]}}
        </div>
      </div>
      <div class="languageSelectContainer">
        <div class="language" @click="setLanguage(langauge.id)" v-for="(langauge, index) in UIComponentData.Languages" :key="index"><span class="langugaeText">{{langauge.message}}</span><span v-if="index!=(UIComponentData.Languages.length-1)">&#12644;|&#12644;</span></div>
      </div>
    </div>
  </question-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import QuestionCard from '@/components/QuestionCard.vue';
import VButton from '@/components/ui-kit/VButton.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';

export default {
  name: 'questionnaire-intro',
  components: {
    QuestionCard,
    PrivacyPolicy,
    VButton
  },
  props: {
    mode: {
      type: String,
      required: true,
      validator(value) {
        return [
          'continue',
          'start',
        ].includes(value);
      },
    },
    UIComponentData: {
      type: Object,
      required: true
    },
  },
  data: () => ({
    leadHandled: false,
  }),
  computed: {
    ...mapGetters(['questionnaireLead', 'curLeadWizard']),
    isStart() {
      return this.mode === 'start';
    },
  },
  methods: {
    ...mapActions(["mutateLead"]),
    handle() {
      this.$emit('route-to-next-slide',true);
    },
    setLanguage(id) {
      this.questionnaireLead.Language = id
      this.mutateLead(this.questionnaireLead);
    },
    routeToHome(){
      if(this.curLeadWizard && this.curLeadWizard.LeadTemplate && this.curLeadWizard.LeadTemplate.HomePageUrl){
        if (window.self !== window.top) {
            window.parent.location.href = this.curLeadWizard.LeadTemplate.HomePageUrl;
          } else {
            window.location.href = this.curLeadWizard.LeadTemplate.HomePageUrl;
          }
      }
    }
  },
  async mounted() {
    this.leadHandled = true;
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.questionnaire-intro {
  max-width: 820px;

  &__agreement {
    font: {
      style: normal;
      weight: normal;
      size: 16px;
    }
    line-height: 22px;
    color: $grey;
    margin: 0 auto;

    &-link {
      &:not(.md-button) {
        text-decoration: none;
      }
    }

  }

  &__navigation {
    text-align: center;

    &-continue {
      margin-bottom: 20px;
      align-items: center;
      display: flex;
      justify-content: space-between;
      flex-flow: wrap;
    }

  }

  &__button {
    display: inline-block;
    height: 60px;
    max-width: 270px;
    letter-spacing: 1.5px;
    margin: 10px auto;
    font: {
      family: 'Roboto';
      weight: 500;
      size: 14px;
    }

    span {
      vertical-align: middle;
      color: white;
    }

    .v-icon.material-icons {
      padding-right: 10px;
      transform: rotate(180deg);
      color: white;
    }
  }

  &__back-link {
    text-transform: uppercase;
    font: {
      family: 'Roboto';
      weight: 500;
      size: 12px;
    }
    letter-spacing: 1.5125px;
    background: black;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

}
.languageSelectContainer{
  display: flex;
  justify-content: center;
  margin-top: 30px;
  flex-flow: wrap;
  .language{
    .langugaeText{
      &:hover, &:focus{
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}
</style>
